import React from "react";
import clsx from "clsx";
import "./chat-box-input.styles.scss";

import { ChatInput } from "../ChatInput";
import { ChatBoxInputButtons } from "../ChatBoxInputButtons";
import { useChatBoxListUIController, useChatBoxViewContext } from "../../contexts";

export interface ChatBoxInputProps {
	className?: string;
}

const BlockName = "chat-box-input";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {},
} as const;

export type ChatBoxInputComponent = React.FC<ChatBoxInputProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxInput = (props: ChatBoxInputProps) => {
	const [chatInputValue, setChatInputValue] = React.useState("");
	const chatBoxListUIController = useChatBoxListUIController();
	const { toUidInfo, fromUidInfo } = useChatBoxViewContext();

	const handleChatInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setChatInputValue(value);
	};

	const handleKeyDownChatInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			const content = chatInputValue.trim();
			if (!content.length) return;

			setChatInputValue("");
			chatBoxListUIController.sendNewTextMessage(
				{
					content,
					fromUid: fromUidInfo.uid,
					toUid: toUidInfo.uid,
				},
				{ shouldPlayAnimation: true },
			);
		}
	};

	const handleSendButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		const content = chatInputValue.trim();
		if (!content.length) return;

		setChatInputValue("");
		chatBoxListUIController.sendNewTextMessage(
			{
				content,
				fromUid: fromUidInfo.uid,
				toUid: toUidInfo.uid,
			},
			{ shouldPlayAnimation: true },
		);
	};

	const handleSendStickerButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		const content = {
			id: 23037,
			cateId: 10398,
			type: 7,
			text: "[^10398.23037^]",
			uri: "23037",
			fkey: 0,
			status: 0,
			stickerUrl: "https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23037&size=130",
			stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23037&size=130",
			stickerWebpUrl: null,
			totalFrames: 0,
			duration: 300,
			effectId: 0,
			checksum: "",
			ext: 0,
			source: 0,
			fss: null,
			fssInfo: null,
			version: 0,
			extInfo: null,
			fetchTs: 1745311325313,
			updateState: 0,
		};
		chatBoxListUIController.addNewStickerMessage(
			{
				content,
				fromUid: fromUidInfo.uid,
				toUid: toUidInfo.uid,
			},
			{ shouldPlayAnimation: true },
		);
	};

	return (
		<div className={clsx(ChatBoxInput.ClassNames.Block, props.className)}>
			<ChatInput
				chatInputValue={chatInputValue}
				onChatInputChange={handleChatInputChange}
				onKeyDownChatInput={handleKeyDownChatInput}
			/>
			<ChatBoxInputButtons
				onClickSendButton={handleSendButtonClick}
				onClickSendStickerButton={handleSendStickerButtonClick}
			/>
		</div>
	);
};
ChatBoxInput.ClassNames = ClassNames;
